import React, { useState, useEffect } from "react";
import { PanelFrame } from "../ui/PanelFrame";
import FlagDropdown from "./FlagDropdown";
import logoSvg from "../assets/brand/LT-LOGO-FIN-3tone.svg";
import AccountCapsule from "./AccountCapsule";
import LoginModal from "./LoginModal";
import "./layout.css";
import TermsAndConditions from "./TermsAndConditions";
import mtsLogo from "../assets/brand/mts-logo-svg.png";
import AaaPanel from "./AaaPanel";
import ServerSelectPanel from "./ServerSelectPanel";
// ServerSelectPanel eingebunden LIVE-STATUS


export function LeftRailHome({ activeWorld, onSelectWorld, isLoadingWorld, onNavigate, onSectionMenu,  }) {
  const [locale, setLocale] = useState("DE");
  const [loginOpen, setLoginOpen] = useState(false);


  const [fontScale, setFontScale] = React.useState(() => {
    const saved = Number(localStorage.getItem("fontScale"));
    return saved === 1 || saved === 1.25 || saved === 1.6 ? saved : 1.25; // Mittel als Default
  });
  
  React.useEffect(() => {
    document.documentElement.style.setProperty("--font-scale", String(fontScale));
    localStorage.setItem("fontScale", String(fontScale));
  }, [fontScale]);

  


  return (
    <PanelFrame>
      {/* Header / Logo */}
      <div
        style={{
          borderRadius: 12,
          background: "rgba(10,12,18,.38)",
          border: "1px solid rgba(28, 46, 73, 0.86)",
          boxShadow:
            "inset 0 1px 0 rgba(255,255,255,.05), 0 -1px 1px rgba(255,255,255,.5), 0 2px 3px rgba(0,0,0,.8)",
          padding: "5px 8px",
          minHeight: 64,
          display: "grid",
          gridTemplateColumns: "1fr auto",
          alignItems: "center",
          boxSizing: "border-box",
          color: "#e6edf3",
          // WICHTIG: kein globaler Pointer-Cursor mehr
          cursor: "default",
        }}
      >
        {/* Nur das Logo ist klickbar */}
        <div
          onClick={() => {
            window.location.href = "/";
          }}
          style={{
            justifySelf: "start",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
          }}
        >
          <img
            src={logoSvg}
            alt="LEGENDSTOOLS"
            style={{ height: 50, display: "block" }}
          />
        </div>
  
        {/* Sprachwahl – nicht im Klickbereich */}
        <div
          style={{
            justifySelf: "end",
            transform: "translateY(14px)",
          }}
        >
          <FlagDropdown value={locale} onChange={setLocale} />
        </div>
      </div>

      {/* Badge HOME */}
      <div style={{ width: "100%" }}>
        <div
          style={{
            marginTop: 5,
            marginBottom: 5,
            borderRadius: 10,
            padding: 0,
            background: "rgba(10,12,18,.1)",
            border: "0px solid rgba(28,46,73,.70)",
            boxShadow: "inset 0 1px 0 rgba(255,255,255,.04)",
            boxSizing: "border-box",
          }}
        >
          <div
            role="status"
            aria-label="Aktives Modul: HOME"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: 34,
              padding: "0 12px",
              borderRadius: 12,
              background: "rgba(0,0,0,.18)",
              boxShadow:
                "inset 0 -1px 3px rgba(255,255,255,.4), inset 0 3px 2px rgba(0,0,0,.5), 0 0px 1px rgba(0,0,0,.25)",
              color: "#8FA8E8",
              fontFamily:
                "DisplayBadge, Avenir Next, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
              fontWeight: 700,
              fontSize: 20,
              letterSpacing: ".1em",
              lineHeight: 1,
              whiteSpace: "nowrap",
              userSelect: "none",
            }}
          >
            ⌂ H O M E
          </div>
        </div>
      </div>

      {/* Account / Login */}
      <AccountCapsule onLogin={() => setLoginOpen(true)} />

    
 


       {/* Badge HOME */}
       <div style={{ width: "100%" }}>
        <div
          style={{
            marginTop: 5,
            marginBottom: 5,
            borderRadius: 10,
            padding: 0,
            background: "rgba(10,12,18,.1)",
            border: "0px solid rgba(28,46,73,.70)",
            boxShadow: "inset 0 1px 0 rgba(255,255,255,.04)",
            boxSizing: "border-box",
          }}
        >
        <ServerSelectPanel
  selected={activeWorld}
  onSelect={onSelectWorld}
  isLoading={isLoadingWorld}
/>
        </div>
      </div>

      {/* Tools & Module Label */}
      <div
        style={{
          fontSize: 18,
          letterSpacing: "0.16em",
          color: "#8fa8e8",
          textAlign: "center",
          marginBottom: 5,
        }}
      >
        === MAIN MENU ===
      </div>


      <button className="topbtn" 
        
        style={{'--bg':'#9c5c01','--shade':'#382101','--stripe':'#664210'}}
  
          onClick={() => onSectionMenu && onSectionMenu("01")}  // Menü für Account öffnen
        
        >
          <span className="label"><span className="t">ACCOUNT | INFOS</span></span>
          <span className="num">０１</span>
          <span className="range">•A4</span>
          <span className="bar"></span>
          <span className="arrows"><i></i><i></i><i></i></span>
          <span className="hatch"></span>
        </button>


        <button className="topbtn" 
       
        style={{'--bg':'#0d4f1a','--shade':'#06290e','--stripe':'#013a1a'}}
        onClick={() => onSectionMenu && onSectionMenu("02")}
        >
          <span className="label"><span className="t">TOOLS | GENERAL</span></span>
          <span className="num">０２</span>
          <span className="range">•G9</span>
          <span className="bar"></span>
          <span className="arrows"><i></i><i></i><i></i></span>
          <span className="hatch"></span>
        </button>

        <button className="topbtn"
        
        style={{'--bg':'#214072','--shade':'#0e1b2b','--stripe':'#03315c'}}
        onClick={() => onSectionMenu && onSectionMenu("03")}
         >
          <span className="label"><span className="t">MAP | STATISTICS</span></span>
          <span className="num">０３</span>
          <span className="range">•M1</span>
          <span className="bar"></span>
          <span className="arrows"><i></i><i></i><i></i></span>
          <span className="hatch"></span>
        </button>

        <button className="topbtn"
        
        style={{'--bg':'#6F0000','--shade':'#2E0000','--stripe':'#570000'}}
        onClick={() => onSectionMenu && onSectionMenu("04")}
        >
          <span className="label"><span className="t">OFFENSE | DEFENCE</span></span>
          <span className="num">０４</span>
          <span className="range">•O5</span>
          <span className="bar"></span>
          <span className="arrows"><i></i><i></i><i></i></span>
          <span className="hatch"></span>
        </button>


        <button className="topbtn"
       
        style={{'--bg':'#685702','--shade':'#373401','--stripe':'#4d4901'}}
        onClick={() => onSectionMenu && onSectionMenu("05")}
        >
          <span className="label"><span className="t">ALLIANZ | META</span></span>
          <span className="num">０５</span>
          <span className="range">•D5</span>
          <span className="bar"></span>
          <span className="arrows"><i></i><i></i><i></i></span>
          <span className="hatch"></span>
        </button>



        <AaaPanel value={fontScale} onSelectScale={setFontScale} />

        <div
          style={{
            fontSize: 12,
            padding: "4px 6px",
            marginTop: 10,
            borderRadius: 6,
            color: "rgba(180,190,210,0.75)",
            textAlign: "center",
          }}
        >
          Engineering, Development & Design:
        </div>
      
      
        <img
  src={mtsLogo}
  alt="mts individual carstyling GmbH"
  style={{
    display: "block",
    margin: "0px auto 14px",
    width: "40%",
    maxWidth: 90,
    opacity: 0.6,
    filter: "drop-shadow(0 0 4px rgba(0,0,0,0.9))",
  }}
/>


<TermsAndConditions onNavigate={onNavigate} />
    {/* Disclaimer */}
    <div
        style={{
          fontSize: 9,
          color: "rgba(180,190,210,0.55)",
          marginTop: 1,
          textAlign: "center",
          letterSpacing: ".15em",
        }}
      >
        © 2025 mts individual carstyling GmbH, Germany
      </div>


      <LoginModal open={loginOpen} onClose={() => setLoginOpen(false)} />
    </PanelFrame>
  );
}

